import {Component, Input, OnInit} from '@angular/core';
import {ModalFunctionConfiguration, ModalTextConfiguration} from "../../interfaces/modal-configuration-interface";
import {ModalRoleEnum} from "../../enums/modal-enum";
import {FormGroup} from "@angular/forms";
import { IonToolbar, IonTitle, IonLabel, IonGrid, IonRow, IonCol, IonButton, ModalController } from '@ionic/angular/standalone';
import { UpperCasePipe } from '@angular/common';

@Component({
    selector: 'app-error-request-modal',
    templateUrl: './error-request-modal.component.html',
    styleUrls: ['./error-request-modal.component.scss'],
    imports: [IonToolbar, IonTitle, IonLabel, IonGrid, IonRow, IonCol, IonButton, UpperCasePipe]
})
export class ErrorRequestModalComponent  implements OnInit {
  confirmButtonText: string = 'Conferma';
  cancelButtonText: string = 'Cancella';
  modalMessage: string = '';
  confirmFunction: () => void;
  cancelFunction: () => void;
  modalTitle: string = 'Errore';

  @Input() set text(text: ModalTextConfiguration) {
    this.modalMessage = text?.modal_message ?? '';
    this.confirmButtonText = text?.confirm_button ?? 'Conferma';
    this.cancelButtonText = text?.cancel_button ?? 'Annulla';
  }

  @Input() set functions(functions: ModalFunctionConfiguration) {
    if(!!functions.confirm_function) {
      this.confirmFunction = functions.confirm_function
    } else {
      this.confirmFunction = this.confirm
    }
    if(!!functions.cancel_function) {
      this.cancelFunction = functions.cancel_function
    } else {
      this.cancelFunction = this.cancel
    }

  }

  constructor(private modalController: ModalController,) {
    this.confirmFunction = this.confirm;
    this.cancelFunction = this.cancel;
  }

  ngOnInit() {}

  cancel() {
    return this.modalController.dismiss(ModalRoleEnum.CANCEL, ModalRoleEnum.CANCEL);
  }

  confirm() {
    return this.modalController.dismiss(null, ModalRoleEnum.CONFIRM);
  }
}
